import domReady from "@wordpress/dom-ready";
import Splide from "@splidejs/splide";

domReady(() => {
	// set some defaults for all slides
	Splide.defaults = {
		type: "fade",
		rewind: true,
		autoplay: false,
		interval: 5000,
		arrows: false,
		// autoHeight: true,
		focus: 'center',
		autoHeight: true,
		breakpoints: {
			768: {
				perPage: 1,
				perMove: 1
			}
		}
	};



	// get the slides
	const elms = document.getElementsByClassName("splide");
	// init slides for each instance
	for (let i = 0; i < elms.length; i++) {

		// randomize
		if (elms[i].dataset.randomizeSlides) {
			let slist = elms[i].querySelector('.splide__list');
			for (let j = slist.children.length; j >= 0; j--) {
				slist.appendChild(slist.children[Math.random() * j | 0]);
			}
		};

		const splide = new Splide(elms[i]);
		const nxtSlideBtns = splide.root.getElementsByClassName('slide-caption__nxtbtn');

		let updateHeight = () => {
			let slide = splide.Components.Slides.getAt( splide.index ).slide;
			slide.parentElement.style.height = slide.offsetHeight + 'px';
			// console.log(slide.offsetHeight);
		};

		for (let j = 0; j < nxtSlideBtns.length; j++) {
			nxtSlideBtns[j].addEventListener(
				"click",
				(e) => {
					e.preventDefault();
					e.stopPropagation(); e.stopImmediatePropagation();
					splide.go('>');
				},
				true
			);
		}
		splide.mount().on( 'active resized', updateHeight );
		updateHeight();
	}



	//get the slides and add click if data-href is available
	var linkedSlides = document.getElementsByClassName(
		"prop-slides-block__child"
	);
	for (var i = 0; i < linkedSlides.length; i++) {
		if (linkedSlides[i].hasAttribute("data-href")) {
			let linkUrl = linkedSlides[i].getAttribute("data-href");
			linkedSlides[i].addEventListener(
				"click",
				(e) => {
					e.stopPropagation();
					location.href = linkUrl;
				},
				false
			);
		}
	}
});
